const ERROR_CLASSNAME = '.ac-errorBlock';
const INPUT_SELECTORS =
	'.ac-input-container input, .ac-input-container textarea, .ac-input-container select';

const getQuestion = (questions, id) => {
	const question = questions.find((ques) => ques.id === id);
	return {
		...question,
		value: (typeof question.value !== 'undefined' && String(question.value)) || null,
	};
};

const updateAttributes = (elements, isRequired) => {
	elements.forEach((el) => {
		el.setAttribute('aria-required', isRequired.toString());
		el.setAttribute('aria-invalid', isRequired.toString());
	});
};

const showError = (parentElement, message) => {
	if (!parentElement.querySelector(ERROR_CLASSNAME)) {
		const errorMessageElement = document.createElement('div');
		errorMessageElement.textContent = message;
		errorMessageElement.className = 'ac-textBlock ac-errorBlock';
		errorMessageElement.style.cssText = `color: rgb(196, 49, 75);`;
		parentElement.appendChild(errorMessageElement);
	}
};

const hideError = (parentElement) => {
	const errorBlock = parentElement.querySelector(ERROR_CLASSNAME);
	if (parentElement.querySelector(ERROR_CLASSNAME)) {
		parentElement.removeChild(errorBlock);
	}
};

const focusOnUnaswered = (ids) => {
	const parentElement = document.getElementById(ids[0])?.querySelector('.ac-input-container');
	const focusElement = parentElement?.querySelector('[aria-required="true"]');
	focusElement.focus();
};

export const validateForm = (requiredQuestions, responses, required) => {
	let unansweredCount = 0;
	const unansweredIds = [];
	for (const id of requiredQuestions) {
		const question = getQuestion(responses, id);
		const parentElement = document.getElementById(id);

		const isRequired = question.value === null;
		const input = parentElement.querySelectorAll(INPUT_SELECTORS);
		updateAttributes(input, isRequired);

		if (isRequired) {
			showError(parentElement, required);
			unansweredIds.push(id);
			unansweredCount++;
		} else {
			hideError(parentElement);
		}
	}

	if (unansweredIds.length > 0) {
		focusOnUnaswered(unansweredIds);
	}

	return unansweredCount === 0;
};

export const hideErrorValidationOnSave = (requiredQuestions) => {
	for (const id of requiredQuestions) {
		const parentElement = document.getElementById(id);
		const inputs = parentElement.querySelectorAll(INPUT_SELECTORS);
		inputs.forEach((el) => el.setAttribute('aria-invalid', 'false'));
		hideError(parentElement);
	}
};
